import { GeofenceLocation } from "@verity/proctoring-option/types";
import { GeofenceLocationWithId } from "../option-modals/GeofenceModal";

// Moved to helper file so vite doesn't complain
export function isGeofenceEqual(geo1: GeofenceLocation | undefined, geo2: GeofenceLocation | undefined): boolean {
	if (!geo1 || !geo2) return false;

	return (
		geo1.name === geo2.name &&
		geo1.latitude === geo2.latitude &&
		geo1.isMetric === geo2.isMetric &&
		geo1.longitude === geo2.longitude &&
		geo1.radius === geo2.radius
	);
}

// Also adds ids
export function getInitialGeofences(
	selectedGeofence: GeofenceLocation | undefined,
	presetGeofences: GeofenceLocation[] | undefined,
): { initialSelectedGeofence: GeofenceLocationWithId | undefined; initialGeofences: GeofenceLocationWithId[] } {
	// Helper to add ID if it doesn't exist
	const addId = (g: GeofenceLocation): GeofenceLocationWithId => ({
		...g,
		id: (g as GeofenceLocationWithId).id ?? crypto.randomUUID(),
	});

	const nonNullpresetGeofences = presetGeofences ? presetGeofences : [];

	const initialGeofences = nonNullpresetGeofences.map(addId);

	let initialSelectedGeofence: GeofenceLocationWithId | undefined = undefined;

	if (selectedGeofence) {
		// Try to find the selected geofence in the list
		initialSelectedGeofence = initialGeofences.find(
			(g) =>
				// Match by ID if it exists, otherwise match by name/coords
				((selectedGeofence as GeofenceLocationWithId).id && g.id === (selectedGeofence as GeofenceLocationWithId).id) ||
				isGeofenceEqual(g, selectedGeofence),
		);

		// If not found in presets (e.g. it's a custom one), give it a stable ID
		if (!initialSelectedGeofence) {
			initialSelectedGeofence = addId(selectedGeofence);
		}
	} else if (initialGeofences.length > 0) {
		initialSelectedGeofence = initialGeofences[0];
	}

	return { initialSelectedGeofence, initialGeofences };
}
